import moment from "moment";

export function CalcDateID(input: Date, eventtype: string): number {
  switch (eventtype) {
    case "806970013":
    case "806970014":
    case "806970015":
    case "806970016":
      return input.getFullYear() * 10000 +
        input.getMonth() * 100;
    default:
      return input.getFullYear() * 10000 +
        input.getMonth() * 100 +
        input.getDate();
  }
}

export function FormatDate(input: Date, eventtype: string): string {

  let dateAsString:string;


  switch (eventtype) {
    case "806970013":
    case "806970014":
    case "806970015":
    case "806970016":
      return moment(input).format("MMMM YYYY");
    default:
      return moment(input).format("D MMMM YYYY");
  }
}
